import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from './compliance-field-modal.scss';
import Button from 'jd-library/Button';
import CustomScrollBar from 'jd-library/CustomScrollBar';
import ActionDialog from 'jd-library/ActionDialog';
import useOnScroll from 'jd-library/useOnScroll';
import { connect } from 'react-redux';

const complianceFieldMapping = {
	manufacturer: 'Manufacturer Name',
	manufactured_details: 'Manufacturer Add. /Contact Details',
	country_of_origin: 'Country Of Origin',
	importer: 'Importer Name',
	importers_detail: 'Importer Add. /Contact Details'
};

const ComplianceFieldModal = ({
	toggleModal,
	deviceData,
	smartFillUpdateProduct,
	smartFillData,
	showLoader
}) => {
	const isMobile = deviceData.isMobile;
	const [scrollEl, setScrollEl] = useState(null);
	const [scrolled, setScroll] = useState(false);
	const scrollDiv = useRef(null);

	const handleScroll = useCallback(e => {
		setScroll(e.target && e.target.scrollTop > 0);
		setScrollEl(scrollDiv);
	}, []);

	useOnScroll({
		callback: (e, scrollObj) => {
			if (scrollObj.currScroll.scrollTop) {
				setScroll(true);
			} else {
				setScroll(false);
			}
		},
		element: !scrollEl ? null : scrollEl,
		deps: [scrollEl]
	});

	let count = smartFillData?.count;
	let category = smartFillData?.categoryName;
	let brand = smartFillData?.brand;

	const renderFields = (title, details) => {
		return (
			<div className={`${styles['marginT10']}`}>
				<div style={{ fontWeight: 500 }}>{title} :</div>
				<div className={`${styles['marginT2']}`}>{details}</div>
			</div>
		);
	};

	const btnArray = [
		{
			variant: 'primary',
			children: 'Update Products',
			className: `${styles['btn-container']}`,
			onClick: () => {
				toggleModal;
			}
		},
		{
			children: `Don't Update Products`,
			className: `${styles['btn-container']}`,
			variant: 'default',
			onClick: () => {
				toggleModal;
			}
		}
	];

	const header = (
		<>
			<div className={`${styles['modal-title']}`}>
				Update Similar {count > 1 ? 'Products' : 'Product'}
			</div>
			<div className={`${styles['modal-information-text']}`}>
				We have identified{' '}
				<span style={{ fontWeight: 500 }}>{count}</span> other{' '}
				{count > 1 ? 'products ' : 'product '}
				belonging to{' '}
				<span style={{ fontWeight: 500 }}>
					{brand} {category}
				</span>{' '}
				in your catalogue.
				<br />
			</div>
		</>
	);
	const component = (
		<div
			className={`${styles['compliance-field-modal']}`}
			ref={scrollDiv}
			onScroll={handleScroll}
		>
			<div
				className={`${styles['marginT5']} ${styles['fields-container']}  ${styles['scroll-modal']}`}
			>
				<div style={{ textAlign: 'center' }}>
					Do you want to update the below information in these
					{count > 1 ? ' products' : ' product'}
				</div>
				{smartFillData?.complianceArr?.map((item, index) => {
					if (!item || item.name == 'brand') {
						return;
					}
					let fieldName =
						complianceFieldMapping[
							item.name == 'Country Of Origin'
								? item.s_name
								: item.name
						];

					return renderFields(
						fieldName,
						item.value ? item.value : ''
					);
				})}
				{/* {renderFields('Manufacturer Name', manufacturerName)}
				{renderFields(
					'Manufacturer Add. /Contact Details',
					manufacturerAddr
				)}
				{renderFields('Country Of Origin', countryOfOrigin)}
				{renderFields('Importer Name', importerName)}
				{renderFields('Importer Add. /Contact Details:', importerAddr)} */}
			</div>
			<div className={`${styles['marginT15']} ${styles['btn-holder']}`}>
				<Button
					children={`Update ${count > 1 ? 'Products' : 'Product'}`}
					className={`${styles['btn-container']}`}
					onClick={() => smartFillUpdateProduct()}
					showLoader={showLoader}
				/>
				<Button
					children={`Don't Update ${
						count > 1 ? 'Products' : 'Product'
					}`}
					className={`${styles['btn-container']}`}
					variant='default'
					onClick={toggleModal}
				/>
			</div>
		</div>
	);

	return (
		<ActionDialog
			settings={{
				modalId: 'flow',
				variant: 'action',
				class: `${styles['compliance-modal-parent']} ${
					scrolled ? styles['isScrolled'] : ''
				}`
			}}
			backdropStatic={true}
			onHidden={toggleModal}
			title={header}
			content={component}
			// btnArray={btnArray}
		/>
	);
};

const mapStateToProps = (state, props) => {
	return {
		deviceData: state.library.deviceData,
		smartFillData: state.products.smartFillData
	};
};
export default connect(mapStateToProps)(ComplianceFieldModal);
